import { createContext, useContext } from 'react'

export const DraftContext = createContext({})
const useDraft = () => useContext(DraftContext)

export default useDraft
